import validationMixin from '@/mixins/validation.mixin.js';
import { TableKeys } from '@/config/tableColumns';

const searchParamValue = [
  { productEventLevel: 'productEventLevelList' },
  { userYn: 'userYnList' },
  { repetitionType: 'repetitionTypeList' },
  { eventLevel: 'eventLevelList' },
  { dbVersion: 'dbVersionList' },
  { saType: 'saTypeList' },
  { type: 'typeList' },
  { nodeType: 'nodeTypeList' },
  { queryEngineType: 'queryEngineTypeList' },
  { productState: 'productStateList' },
  { agentType: 'agentTypeList' },
  { agentState: 'agentStateList' },
  { agentVersion: 'agentVersionList' },
  { disableYn: 'disableYnList' },
  { haType: 'haTypeList' },
  { repetitiontType: 'repetitiontTypeList' },
  { appVersion: 'appVersionList' },
  { projectName: 'projectIds' }
];
let tableMixin = {
  extends: validationMixin,
  methods: {
    changeRowPerPage() {
      this.page.currentPage = 1;
      this.page.currentIndex = (this.page.currentPage - 1) * this.page.rowsPerPage;
      this.tableUpdated('changeRowPerPage');
    },
    changeCurrentPage(page) {
      this.page.currentPage = page;
      this.page.currentIndex = (page - 1) * this.page.rowsPerPage;
      this.tableUpdated('changeCurrentPage');
    },
    tableUpdated() {
      this.refresh();
    },
    setTableInfo(data, selectReset = true) {
      if (selectReset) this.selected = [];
      this.items = data.contents;
      this.page.totalItems = data.totalCount;
      this.noDataText = '';
    },
    setAccessDeniedMessage(message = 'message.accessErrorListMonitor') {
      this.selected = [];
      this.items = [];
      this.page.totalItems = 0;
      this.noDataText = this.t(message);
    },
    reset() {
      let keys = Object.keys(this.searchModel);
      keys.forEach((key) => {
        this.searchModel[key] = '';
      });
      this.selectedFilter = this.$util.deepCopy(this.searchModel);
      this.resetFilter();
    },
    resetFilter() {
      let keys = [];
      if (this.$refs.filter && this.$refs.filter.$refs) {
        keys = Object.keys(this.$refs.filter.$refs);
      }
      keys.forEach((key) => {
        if (this.$refs.filter.$refs[key] && this.$refs.filter.$refs[key].txtField) {
          this.$refs.filter.$refs[key].txtField = '';
        }
      });
    },
    filterSearch() {
      this.selectedFilter = this.$util.deepCopy(this.searchModel);
      this.doSearch(null, null, this.selectedFilter);
    },
    search(currentPage = null) {
      let searchFilter = this.$util.deepCopy(this.selectedFilter);
      this.doSearch(this.searchKey, this.searchText, searchFilter, currentPage);
    },
    getSearchParam(searchParam) {
      this.currentSearchParam = searchParam;
      let param = { page: this.page.currentPage - 1, size: this.page.rowsPerPage };
      if (searchParam != null) {
        param = Object.assign(param, searchParam);
      }
      param.sort = [];
      if (this.sort.sortDataField != null && this.sort.sortDataField.length > 0) {
        param.sort = [
          this.sort.sortDataField + (this.sort.sortOrder ? ':' + this.sort.sortOrder : '')
        ];
      }
      return param;
    },
    doSearch(searchKey, searchText, searchFilter = {}, currentPage) {
      Object.keys(searchFilter).forEach((key) => {
        if (
          searchFilter[key] &&
          !Array.isArray(searchFilter[key]) &&
          typeof searchFilter[key] === 'string'
        ) {
          searchFilter[key] = searchFilter[key].trim();
        }
      });

      let searchParam = { ...searchFilter };
      if (searchKey && searchText) {
        searchParam.searchKey = searchKey;
        searchParam.searchValue = searchText;
      }
      this.currentSearchParam = searchParam;
      this.changeCurrentPage(currentPage || 1);
    },
    onClickSort(sortItem, keepSelected = false) {
      this.sort.sortDataField = sortItem.value;
      this.sort.sortOrder = sortItem.asc ? 'asc' : 'desc';
      this.page.currentPage = 1;
      this.page.currentIndex = 0;
      this.getData(this.currentSearchParam, keepSelected);
    },
    onSearchField(field, value) {
      Object.keys(this.searchModel).forEach((key) => {
        if (key !== 'productTypeCode') {
          this.searchModel[key] = '';
          this.searchModel.productIdList = [];
        }
      });
      if (value) {
        this.selectedFilter = { [field]: value, productTypeCode: this.searchModel.productTypeCode };
      } else {
        this.selectedFilter = this.$util.deepCopy(this.searchModel);
      }
      this.doSearch(null, null, this.selectedFilter, 1);
    },
    tranferSearchParam(searchParam, isEventSetting = false, isEventStatus = false) {
      searchParamValue.forEach((value) => {
        const param = Object.keys(value)[0];
        if (searchParam[param] && Array.isArray(searchParam[param])) {
          searchParam[value[param]] = searchParam[param].map((item) => {
            return item['key'];
          });
          searchParam[param] = '';
        }
      });

      if (searchParam.productTags && Array.isArray(searchParam.productTags)) {
        searchParam.productTags = searchParam.productTags.map((tag) => tag.text).toString();
      }

      if (isEventStatus) {
        if (searchParam.productTypeCode == 'WAN' && !Array.isArray(searchParam.productIdList)) {
          searchParam.productName = searchParam.productIdList;
          searchParam.productIdList = [];
        } else if (Array.isArray(searchParam.productIdList)) {
          let productIdListVal = searchParam.productIdList.map((item) => item.key);
          if (productIdListVal[0]) {
            searchParam.productIdList = productIdListVal;
          }
        } else {
          searchParam.productIdList = [];
          searchParam.productName = '';
        }
      }

      if (searchParam.productName != undefined && Array.isArray(searchParam.productName)) {
        if (isEventSetting) {
          searchParam.productName = '';
        } else {
          searchParam.productIdList = searchParam.productName.map((item) => {
            return item['key'];
          });
          searchParam.productName = '';
        }
      }

      if (
        searchParam.eventState &&
        Array.isArray(searchParam.eventState) &&
        searchParam.eventState.length == 1
      ) {
        searchParam.eventState = searchParam.eventState
          .map((item) => {
            return item['key'];
          })
          .toString()
          .toLocaleUpperCase();
      } else if (
        searchParam.eventState &&
        Array.isArray(searchParam.eventState) &&
        (searchParam.eventState.length > 1 || searchParam.eventState.length == 0)
      ) {
        searchParam.eventState = 'ALL';
      }
      if (searchParam.metricKeyList != undefined && Array.isArray(searchParam.metricKeyList)) {
        searchParam.metricKeyList = searchParam.metricKeyList.map((item) => {
          return {
            metricKey: item['key'] || item.metricKey,
            objectType: item['type'] || item.objectType
          };
        });
        searchParam.metricName = '';
      }
    },
    ResetParamSearch() {
      if (this.searchModel.productState != undefined) this.searchModel.productState = [];
      if (this.searchModel.agentType != undefined) this.searchModel.agentType = [];
      if (this.searchModel.agentState != undefined) this.searchModel.agentState = [];
      if (this.searchModel.agentVersion != undefined) this.searchModel.agentVersion = [];
      if (this.searchModel.productName != undefined) this.searchModel.productName = [];
      if (this.searchModel.saType != undefined) this.searchModel.saType = [];
      if (this.searchModel.dbVersion != undefined) this.searchModel.dbVersion = [];
      if (this.searchModel.productEventLevel != undefined) this.searchModel.productEventLevel = [];
      if (this.searchModel.queryEngineType != undefined) this.searchModel.queryEngineType = [];
      if (this.searchModel.nodeType != undefined) this.searchModel.nodeType = [];
      if (this.searchModel.type != undefined) this.searchModel.type = [];
      if (this.searchModel.haType != undefined) this.searchModel.haType = [];
      if (this.searchModel.eventLevel != undefined) this.searchModel.eventLevel = [];
      if (this.searchModel.disableYn != undefined) this.searchModel.disableYn = [];
      if (this.searchModel.productIdList != undefined) this.searchModel.productIdList = [];
    },
    resetSort() {
      this.sort = {
        sortDataField: '',
        sortOrder: ''
      };
    },
    refresh(marker = '') {
      if (this.$refs && this.$refs.refLegoPagingTable)
        this.$refs.refLegoPagingTable.$refs.table.clearErrorMessage();

      this.getData(this.currentSearchParam, marker);
    },
    deleteConfirm(key) {
      let param = this.selected.reduce((acc, cur) => {
        return (acc = [...acc, cur[key]]);
      }, []);
      this.$modal.open({
        type: 'confirm',
        title: '알림',
        message: `선택한 ${this.selected.length}개의 항목을 삭제하시겠습니까`,
        action: () => {
          this.deleteProcess(param);
        },
        cancel: () => {}
      });
    },
    transSearchParamsQuery(params) {
      let queryParams = '';
      if (params) {
        for (const key in params) {
          queryParams += `${key}=${encodeURIComponent(params[key])}&`;
        }
      }
      return queryParams.substring(0, queryParams.length - 1);
    },

    /**
     * Function to handle current page when removing items in data table
     *  */
    handleCurrentPage(selected, items, currentPage, rowsPerPage) {
      const diff = Math.floor((selected.length - items.length) / rowsPerPage);
      if (diff >= 0 && currentPage > 1) {
        currentPage = currentPage - 1;
        if (diff >= 1) {
          currentPage = currentPage - diff;
        }
      }
      return currentPage <= 0 ? 1 : currentPage;
    },
    resetSortPaging() {
      this.resetSort();
      if (typeof this.$refs.refLegoPagingTable != 'undefined') {
        this.$refs.refLegoPagingTable.$refs.table.resetSort();
      }
    },
    getSearchParamWithTrim(searchParams) {
      let param = this.getSearchParam(searchParams);
      Object.keys(param).forEach((k) => {
        if (typeof param[k] == 'string') {
          param[k] = param[k].trim();
        }
      });
      return { param };
    },
    handleAccessDenied(error) {
      if (error && error.code == 'AccessDenied')
        this.$alert(error, () =>
          this.setAccessDeniedMessage(
            `${'message.accessError' + error.params.find((item) => item.name == 'action').value}`
          )
        );
    }
  },
  data() {
    return {
      items: [],
      page: {
        rowsPerPage: 20,
        currentPage: 1,
        totalItems: 0,
        currentIndex: 0
      },
      sort: {
        sortDataField: '',
        sortOrder: ''
      },
      selected: [],
      selectedFilter: {},
      currentSearchParam: {},
      noDataText: ''
    };
  },
  computed: {
    tableKeys() {
      return TableKeys;
    }
  }
};
export default tableMixin;
